export default "__VITE_ASSET__1615100c__"